import { render } from "./mainPage.vue?vue&type=template&id=6dba185e&scoped=true"
import script from "./mainPage.vue?vue&type=script&lang=js"
export * from "./mainPage.vue?vue&type=script&lang=js"

import "./mainPage.vue?vue&type=style&index=0&id=6dba185e&scoped=true&lang=css"

import exportComponent from "D:\\yuqiang\\笔记\\git-document\\document\\workspace\\modingtech\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dba185e"]])

export default __exports__